import { RegisterDevToolsCommands } from "commands/registrations/useRegisterDevToolsCommands";
import { StyledMonaco } from "components/Layout/EditorLoader";
import { useActiveFileSync } from "components/Layout/Panels/VSCode/useActiveFileSync";
import { useReadonlyHandler } from "components/Layout/Panels/VSCode/useReadonlyStatus";
import { RegisterCommands } from "components/Layout/RegisterCommands";
import { Box } from "prism-react";
import { useEffect, useRef } from "react";

import { CustomEditors } from "../CommonVSCode/CustomEditors";
import { TopBarItems } from "../TopbarItems";

import { NewDevtoolEditor } from "./NewDevtoolEditor";
import { SidebarItems } from "./Sidebar";
import { IGNORED_TAB_TYPES } from "./devtool-window-manager";
import { useLayoutSync } from "./useLayoutSync";

export const WebVSCode: React.FC<{
  hasLoadedVSCode: boolean;
  vscodeElement: HTMLDivElement;
}> = ({ hasLoadedVSCode, vscodeElement }) => {
  const vscodeRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const ref = vscodeRef.current;
    if (ref) {
      ref.appendChild(vscodeElement);
    }

    return () => {
      if (ref) {
        ref.removeChild(vscodeElement);
      }
    };
  }, [vscodeElement]);

  useReadonlyHandler();
  useLayoutSync();
  useActiveFileSync({
    ignoredTabTypes: IGNORED_TAB_TYPES,
  });

  return (
    <>
      <Box
        css={{
          borderBottom:
            "1px solid var(--vscode-header-border, $neutral-bg-low)",
          height: "44px",
        }}
      >
        {hasLoadedVSCode && <TopBarItems />}
      </Box>

      <StyledMonaco>
        <div
          ref={vscodeRef}
          style={{ width: "100vw", height: "calc(100vh - 44px)" }}
        />
      </StyledMonaco>

      <CustomEditors />
      {hasLoadedVSCode && <RegisterCommands layout={false} />}
      <NewDevtoolEditor />
      <RegisterDevToolsCommands />
      <SidebarItems />
    </>
  );
};
